module.exports = __webpack_public_path__ + "static/unesco_fr-943a8c790d8493cc2594d36aa9b6d15a.png";